import React, { useEffect, useState, useRef } from "react";

const useScrollDirection = () => {
  const pageSection = useRef(null);
  const [scrollDirection, setScrollDirection] = useState(null);
  const prevOffset = useRef(0);

  const SENSITIVE_DEGREE = 51; // 탭바의 높이보다 값이 커야함(otherwise, 스크롤값 충돌 이슈 발생)

  const toggleScrollDirection = (e) => {
    const target = e.currentTarget;
    const scrollY = target.scrollTop;
    if (scrollY === 0) {
      setScrollDirection(null);
    }

    if (Math.abs(scrollY - prevOffset.current) >= SENSITIVE_DEGREE) {
      if (scrollY > prevOffset.current) {
        setScrollDirection("down");
      } else if (scrollY < prevOffset.current) {
        setScrollDirection("up");
      }
      prevOffset.current = scrollY;
    }
  };

  useEffect(() => {
    pageSection.current = document.getElementById("page_section");
  }, []);

  useEffect(() => {
    if (!pageSection.current) return;
    pageSection.current.addEventListener("scroll", toggleScrollDirection);
    return () => {
      pageSection.current.removeEventListener("scroll", toggleScrollDirection);
    };
  });

  return scrollDirection;
};
export default useScrollDirection;
